import React, { Component } from 'react'
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import Subadminsidebar from "../SubAdminSideBar"
import queryString from "query-string";
import UserLogs from '../UserLogs';
import AdminSideNavBar from '../AdminSideNavBar';

const adminUserLogPage = (props) => {
  if (props.location.search) {
    let values = queryString.parse(props.location.search);
    sessionStorage.setItem("token", values.token);
  }
    return (
      <AdminSideNavBar>
        <UserLogs />
      </AdminSideNavBar>
    );
  };
  export default NetworkDetector(adminUserLogPage);
